




























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Textarea extends Vue {
  @Prop({ type: Boolean, default: false })
  blue_icon!: boolean;

  @Prop({ type: Boolean, default: false })
  require!: boolean;

  get classes() {
    return [
      'text-field',
      { blue_icon: this.blue_icon },
      { require: this.require },
    ];
  }
}
